module.exports = __webpack_public_path__ + "static/img/testImg.29652cf3.png";